{
    "TermsAndConditions_Title": "Termini e Condizioni",
    "TermsAndConditions_Subtitle": "I termini e le condizioni d'uso dell'applicazione sono riportati di seguito. Si prega di accettarli selezionando \"Accetto i termini del servizio\" e cliccando sul pulsante \"Accetta\".",
    "TermsAndConditions_Subtitle_NoAccept": "Di seguito sono riportati i nostri termini di servizio standard.",
    "TermsAndConditions_AcceptText": "Accetto i termini e le condizioni",
    "TermsAndConditions_AcceptButton": "Accettare",
    "TermsAndConditions_CloseButton": "Vicino",
    "NAME": "TermsAndConditions"
}